<div class="grid">
    <p-card *ngIf="editingAllowed === false" class="col-12" header="Bearbeitung nicht freigegeben">
        <span style="color: red">Die Bearbeitung der Zeugnisse wurde durch den Administrator noch nicht freigegeben.</span>
    </p-card>
</div>
<ng-container *ngIf="editingAllowed && inited">
    <sm-toolbar>
        <button pButton *ngIf="!isPast" icon="fas fa-save" label="Speichern" (click)="save()">
        </button>
        <button pButton icon="fas fa-save" label="Klassenspiegel exportieren" (click)="export()">
        </button>
        @if (supportsSemester) {
            <span class="ml-3">{{enaioSchoolClass.grade == 12 ? 'Semester: ' : 'Halbjahr: '}}</span>
            <p-dropdown [styleClass]="'width200'" id="semester" [options]="semesterOptions" [(ngModel)]="selectedSemester" (ngModelChange)="gradeUpdated()"></p-dropdown>
        }                        
        <p-message *ngIf="bufferedIsChanged" severity="warning" text="WICHTIG: Alle vorgenommen Änderungen werden erst beim Betätigen des Speichern-Buttons dauerhaft übernommen"></p-message>
    </sm-toolbar>
    <div class="card">
        <p-tabView>
            <p-tabPanel header="Klassenübersicht">
                <p-table [value]="pupils" sortField="lastName" [styleClass]="'p-datatable-gridlines'">
                    <ng-template pTemplate="header">
                    <tr>
                        <th class="text-left" style="width: 40px">#</th>
                        <th class="text-left" style="width:155px" [pSortableColumn]="'lastName'">Nachname<p-sortIcon [field]="'lastName'"></p-sortIcon></th>
                        <th class="text-left" style="width:155px" [pSortableColumn]="'firstName'">Vorname<p-sortIcon [field]="'firstName'"></p-sortIcon></th>
                        <th *ngFor="let domain of domains" class="text-left" style="height:150px; width: 50px"><span style="writing-mode: vertical-rl; height: 100%">{{domain.label}}</span></th>
                        <th class="primary-color" [attr.colspan]="gradeSettings.gradeType == _GradeType.percent ? gradeSettings.isUseTextualGrades() ? 3 : 2 : 1" style="width: 200px">&Oslash;</th>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-pupil let-index="rowIndex">
                    <tr [pSelectableRow]="pupil">
                        <td>{{index + 1}}</td>
                        <td>{{pupil.lastName}}</td>
                        <td>{{pupil.firstName}}</td>
                        <td *ngFor="let domain of domains" class="text-left">{{formatValueBoth(averageMap[pupil.id + "|" + domain.label], averageMapTextualGrade[pupil.id + "|" + domain.label], gradeSettings.gradeType == _GradeType.percent ? _NumberFormatMode.decimalZero : _NumberFormatMode.decimalOne)}}</td>
                        <td class="primary-color" style="width: 50px">{{formatValue(averageMap[pupil.id + "|"], _NumberFormatMode.decimalOne)}}</td>
                        <td *ngIf="gradeSettings.gradeType == _GradeType.percent" class="primary-color" style="width: 150px">{{formatTextualGrade(averageMap[pupil.id + "|"])}}</td>
                        <td *ngIf="gradeSettings.gradeType == _GradeType.percent && gradeSettings.isUseTextualGrades()" class="primary-color" style="width: 50px">{{formatValue(averageMapTextualGrade[pupil.id + "|"])}}</td>
                    </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
            <p-tabPanel header="Fachnoten">
                <div class="">
                    <sm-toolbar>
                        <p-dropdown [styleClass]="'width300'" id="domain" [options]="domains" [(ngModel)]="selectedDomain" (ngModelChange)="updatePupilsTable()"></p-dropdown>
                        <button pButton icon="fas fa-eye" label="Leistungsarten anzeigen" (click)="showExamTypes($event)">
                        </button>
                        <button pButton icon="fas fa-plus" (click)="addExam($event)"></button>
                        <p-checkbox label="Übersetzung anzeigen" name="showTranslation" [(ngModel)]="showTranslation" [binary]="true" (ngModelChange)="updatePupilsTable()"></p-checkbox>
                    </sm-toolbar>
                    <sm-table2 [data]="pupilsTable" [compact]=false [autoHeight]=true [useTableMenu]=false [useColumnMenu]=false [tabForSameRow]=true [headerHeight]=80  (onCellEditingStopped)="gradeUpdated()">
                    </sm-table2>
                </div>
            </p-tabPanel> 
            <p-tabPanel *ngIf="useHeadNotes" header="Kopfnoten">
                <p-table [value]="pupils" sortField="lastName" [styleClass]="'p-datatable-gridlines'" (onEditComplete)="gradeUpdated()">
                    <ng-template pTemplate="header">
                    <tr>
                        <th class="text-left" style="width: 50px">#</th>
                        <th class="text-left" [pSortableColumn]="'lastName'">Nachname<p-sortIcon [field]="'lastName'"></p-sortIcon></th>
                        <th class="text-left" [pSortableColumn]="'firstName'">Vorname<p-sortIcon [field]="'firstName'"></p-sortIcon></th>
                        <th *ngFor="let grade of conductCompetencies" class="text-left" style="height:250px; width: 50px"><span style="writing-mode: vertical-rl; height: 100%">{{grade.title}}</span></th>
                        <th class="primary-color" colspan=2 style="width: 200px">&Oslash;</th>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-pupil let-index="rowIndex">
                    <tr [pSelectableRow]="pupil">
                        <td>{{index + 1}}</td>
                        <td>{{pupil.lastName}}</td>
                        <td>{{pupil.firstName}}</td>
                        <td *ngFor="let grade of conductCompetencies" pEditableColumn class="text-left mouse-pointer">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <sm-grade-editor [value]="conductGradeMap[pupil.id.toString() + '|' + grade.id.toString()]"  [gradeType]="gradeSettings.gradeType"></sm-grade-editor>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{formatValue(conductGradeMap[pupil.id.toString() + '|' + grade.id.toString()].grade, _NumberFormatMode.decimalZero)}}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td class="primary-color" style="width: 50px">{{formatValue(averageMap[pupil.id + "|conduct"])}}</td>
                        <td class="primary-color" style="width: 150px">{{formatTextualGrade(averageMap[pupil.id + "|conduct"])}}</td>
                    </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
            <p-tabPanel header="Historie">
                <p-table [value]="copiedHistory" sortField="changeDate" [sortOrder]="-1">
                    <ng-template pTemplate="header">
                    <tr>
                        <th class="text-left" [pSortableColumn]="'changeDate'" [style.width.px]="200">Datum/Uhrzeit<p-sortIcon [field]="'changeDate'"></p-sortIcon></th>
                        <th class="text-left" [pSortableColumn]="'changedBy'" [style.width.px]="150">Benutzer<p-sortIcon [field]="'changedBy'"></p-sortIcon></th>
                        <th class="text-left" [pSortableColumn]="'pupilId'">Schüler<p-sortIcon [field]="'modification'"></p-sortIcon></th>
                        <th class="text-left" [pSortableColumn]="'modification'">Änderung<p-sortIcon [field]="'modification'"></p-sortIcon></th>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-entry>
                    <tr [pSelectableRow]="entry">
                        <td>{{entry.changeDate | date: 'dd.MM.yyyy HH:mm'}}</td>
                        <td>{{entry.changedBy}}</td>
                        <td>{{entry.pupilId == 0 ? "---" : pupilNamesById[entry.pupilId] || "-Unbekannt-"}}</td>
                        <td>{{entry.modification}}</td>
                    </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
        </p-tabView>
    </div>
</ng-container>

<p-overlayPanel #opExamTypeFactors>
    <ng-template pTemplate>
        <sm-table class="col-12" [data]="examTypeFactorsTable" [allowExport]="false"></sm-table>
    </ng-template>
</p-overlayPanel>



